import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ClientiComponent } from './pages/clienti/clienti.component';
import { PreventiviComponent } from './pages/preventivi/preventivi.component';
import { PreventivoDetailComponent } from './pages/preventivo-detail/preventivo-detail.component';
import { FattureComponent } from './pages/fatture/fatture.component';
import { FatturaDetailComponent } from './pages/fattura-detail/fattura-detail.component';
import { AppuntamentiComponent } from './pages/appuntamenti/appuntamenti.component';
import { ImpostazioniComponent } from './pages/impostazioni/impostazioni.component';
import { HelpComponent } from './pages/help/help.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { 
    path: '', 
    component: DashboardComponent, 
    canActivate: [authGuard] 
  },
  { 
    path: 'clienti', 
    component: ClientiComponent, 
    canActivate: [authGuard] 
  },
  { 
    path: 'preventivi', 
    component: PreventiviComponent, 
    canActivate: [authGuard] 
  },
  { 
    path: 'preventivi/nuovo', 
    component: PreventivoDetailComponent, 
    canActivate: [authGuard] 
  },
  { 
    path: 'preventivi/:id', 
    component: PreventivoDetailComponent, 
    canActivate: [authGuard] 
  },
  { 
    path: 'fatture', 
    component: FattureComponent, 
    canActivate: [authGuard] 
  },
  { 
    path: 'fatture/nuova', 
    component: FatturaDetailComponent, 
    canActivate: [authGuard] 
  },
  { 
    path: 'fatture/:id', 
    component: FatturaDetailComponent, 
    canActivate: [authGuard] 
  },
  { 
    path: 'appuntamenti', 
    component: AppuntamentiComponent, 
    canActivate: [authGuard] 
  },
  { 
    path: 'impostazioni', 
    component: ImpostazioniComponent, 
    canActivate: [authGuard] 
  },
  { 
    path: 'help', 
    component: HelpComponent, 
    canActivate: [authGuard] 
  },
  { path: '**', redirectTo: '' }
];
